/** Мок API: вход. */
import { NO_HISTORY } from "@newfungame/contracts";
import type { FakeDb, FakeHandlers } from "./db";

export function authHandlers(db: FakeDb): FakeHandlers<"authTelegram" | "authGuest" | "authTelegramLogin"> {
  const signIn = () => ({ state: db.fresh(), created: false, merged: false, history: NO_HISTORY });
  return {
    authTelegram: async () => signIn(),
    authGuest: async () => signIn(),
    authTelegramLogin: async () => ({ ...signIn(), merged: true }),
  };
}
